import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { ScheduleSettingsDialogService } from './../../core/services/dialog-services/schedule-dialog.service';
import { DeleteDialogService } from '../../core/services/dialog-services/delete-dialog.service';
import { TagService } from '../../core/services/http-services/tag.service';

import { MonitorMenuComponent } from './monitor-menu.component';
import { MonitorHub } from '../../shared-module/hubs/monitor.hub';
import { Schedule } from '../../core/models/entities/schedule.type';
import { ScheduleType } from '../../core/models/enums/schedule-type.enum';
import { ScheduleModalMode } from './../../core/enums/schedule-model-mode.enum';
import { RemoteControlService } from '../../core/services/http-services/remote-control.service';

@Component({
  selector: 'timeline-monitor-menu',
  styleUrls: ['./monitor-menu.component.scss'],
  templateUrl: './timeline-monitor-menu.component.html',
  host: {
    '(document:click)': 'clickedOutside()',
    '(document:contextmenu)': 'clickedOutside($event)'
  }
})

export class TimelineMonitorMenuComponent extends MonitorMenuComponent implements OnInit {

  public schedule: Schedule;

  subtitle;
  apiUrl = '';

  constructor(
    public toastrService: ToastrService,
    private readonly scheduleDialog: ScheduleSettingsDialogService,
    public readonly tagService: TagService,
    public readonly deleteDialogService: DeleteDialogService,
    public readonly router: Router,
    public readonly dialog: MatDialog,
    public readonly remoteControlService: RemoteControlService,
    public readonly monitorHub: MonitorHub,
    public readonly renderer: Renderer2
  ) {
      super(toastrService, tagService, deleteDialogService, router, dialog, remoteControlService, monitorHub, renderer);
  }
  ngOnInit(): void {
    this.subtitle = 'Plays ';
    if (this.schedule.AllDay) {
      this.subtitle += 'all day ';
    } else {
      this.subtitle += 'from ' + this.schedule.StartTime.substr(0, 5) + ' to ' + this.schedule.EndTime.substr(0, 5) + ' ';
    }

    if (this.schedule.ScheduleType === ScheduleType.Daily) {
      this.subtitle += 'every day';
    } else if (this.schedule.ScheduleType === ScheduleType.Weekly) {
      this.subtitle += 'in certain days every week';
      // to do: specify days
    } else if (this.schedule.ScheduleType === ScheduleType.ByDate) {
      this.subtitle += 'from ' + this.schedule.StartDate + ' to ' + this.schedule.EndDate;
    }
  }

  onEdit(): void {
    if (this.schedule) {
      this.scheduleDialog.show(
        this.schedule,
        this.schedule.On ? ScheduleModalMode.Edit : ScheduleModalMode.TurnOn
      );
    }
  }
}
